import React, { useState, useEffect } from "react";
import "../assets/css/InstallPrompt.css";
import bg_white from "../assets/img/bg_white.png";

const InstallPrompt = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Check if already installed or dismissed
    const alreadyInstalled = localStorage.getItem("appInstalled");
    const dismissed = localStorage.getItem("appDismissed");

    if (!alreadyInstalled && !dismissed) {
      const timer = setTimeout(() => {
        setShowPopup(true);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleInstall = () => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(ua)) {
      // 👉 Android
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.rent.el.in";
    } else if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) {
      // 👉 iOS
      window.location.href = "https://www.apple.com/app-store/";
    } else {
      // 👉 Fallback (Desktop/Web) → Play Store
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.rent.el.in";
    }

    // Mark as installed
    localStorage.setItem("appInstalled", "true");
    setShowPopup(false);
  };

  useEffect(() => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;

    const isMobile =
      /android/i.test(ua) ||
      (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) ||
      window.innerWidth <= 768; // extra safety

    if (!isMobile) return; // ❌ Desktop → popup nahi

    const alreadyInstalled = localStorage.getItem("appInstalled");
    const dismissed = localStorage.getItem("appDismissed");

    if (!alreadyInstalled && !dismissed) {
      const timer = setTimeout(() => {
        setShowPopup(true);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleLater = () => {
    // Mark as dismissed (so popup won't show again)
    localStorage.setItem("appDismissed", "true");
    setShowPopup(false);
  };

  if (!showPopup) return null;

  return (
    <div className="install-popup">
      <div className="popup-headerg">
        <img src={bg_white} alt="App Icon" className="popup-icon" />
        <h3>Install Our App</h3>
      </div>

      <p>Better experience with our mobile app.</p>

      <div className="btn-group">
        <button className="install-btn" onClick={handleInstall}>
          Install
        </button>
        <button className="later-btn" onClick={handleLater}>
          Later
        </button>
      </div>
    </div>
  );
};

export default InstallPrompt;
